import React from 'react';
import ReactDOM from 'react-dom';
import {actions, InputTypeField, Loader, TextField} from "react-fields";
import loginAPI from '../api/loginAPI';
import HoverButton from "../buttons/HoverButton";

class Login extends React.Component {
    passwordContainerRef = React.createRef();

    state = {
        user: {email: this.props.user.email, errors: {}},
        isLoading: false,
        currentStep: 'email',
        className: this.props.className || "form-container"
    };

    componentDidMount() {
        let emailField = document.querySelector('input[name="email"]');
        if (emailField) {
            emailField.focus();
        }
    }

    afterLogin = (user) => {
        console.log('afterLogin');
       if(!!this.props.afterLogin){
           this.setState({isLoading: false});
           this.props.afterLogin(user);
       } else {
           document.location.href = this.props.continue_path || '/group/overview';
       }
    };

    login = (e) => {
        e.preventDefault();
        let _this = this;
        this.setState({isLoading: true}, () => {
            let user = _this.state.user;
            loginAPI.loginUser(this.state.user, this.props.saveAnswers).then( async (response) => {
                if (response) {
                    localStorage.clear();
                    _this.afterLogin(response);
                } else {
                    _this.setState({isLoading: false});
                }

            }).catch(error => {
                console.log(error);
                error.json().then(function (value) {
                    user.errors = value;
                    _this.setState({user: user, isLoading: false});
                });
            });
        })

    };

    onHandleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        let user = this.state.user;
        user[name] = value;
        user.errors.base = "";
        user.errors[actions.camelize(name)] = "";
        this.setState({user: user});

    };

    submitOnEnter = (e) => {
        if(e.key === 'Enter'){
            this.login(e);
        }
    };

    render() {
        return  (

            <form onSubmit={this.login}>
                {this.state.isLoading ? <Loader/> : null}
                <div className="grid-x">
                    <div className="small-12 cell">
                        <TextField name={"email"}
                                   placeholder={"Email"}
                                   errorMessage={this.state.user.errors.email || this.state.user.errors.base}
                                   value={this.state.user.email}
                                   onChange={this.onHandleChange}
                        />
                    </div>
                    <div className="small-12 cell" ref={this.passwordContainerRef}>
                        <InputTypeField type={"password"} name={"password"}
                                        placeholder={"Password"}
                                        errorMessage={this.state.user.errors.password || this.state.user.errors.base}
                                        value={this.state.user.password}
                                        onKeyPress={this.submitOnEnter}
                                        onChange={this.onHandleChange} />
                    </div>
                </div>
                <div className="grid-x align-middle">
                    <div className="small-6 cell forgot-password">
                        <a onClick={this.props.onClickForgotPassword}>Forgot Password</a>
                    </div>
                    <div className="small-6 cell flex-end">
                        <HoverButton onClick={this.login}>
                            Log In
                        </HoverButton>
                    </div>
                </div>
            </form>
        )
    }


}
export default Login;